module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout', [(_vm.isMobile) ? _c('drawer', {
    attrs: {
      "openDrawer": _vm.collapsed
    },
    on: {
      "change": _vm.onDrawerChange
    }
  }, [_c('sider-menu', {
    attrs: {
      "theme": _vm.theme,
      "menuData": _vm.menuData,
      "collapsed": false,
      "collapsible": false
    },
    on: {
      "menuSelect": _vm.onMenuSelect
    }
  })], 1) : (_vm.layout === 'side') ? _c('sider-menu', {
    attrs: {
      "theme": _vm.theme,
      "menuData": _vm.menuData,
      "collapsed": _vm.collapsed,
      "collapsible": true
    }
  }) : _vm._e(), _vm._v(" "), _c('drawer', {
    attrs: {
      "open-drawer": _vm.settingBar,
      "placement": "right"
    }
  }, [_c('setting')], 1), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "min-height": "100vh",
      "overflow-y": "hidden"
    },
    style: ({
      paddingLeft: _vm.paddingLeft
    })
  }, [_c('global-header', {
    attrs: {
      "menuData": _vm.menuData,
      "collapsed": _vm.collapsed
    },
    on: {
      "toggleCollapse": _vm.toggleCollapse
    }
  }), _vm._v(" "), _c('a-layout-content', {
    class: _vm.fixHeader ? 'fixed-header-content' : null,
    style: ({
      minHeight: _vm.minHeight,
      margin: '20px 14px 0'
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (this.$route.meta.fullPageContent === false) ? _c('a-layout-footer', {
    staticClass: "copyright",
    staticStyle: {
      "padding": ".29rem 0"
    }
  }, [_c('global-footer', {
    attrs: {
      "copyright": _vm.copyright
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0fae208c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/GlobalLayout.vue
// module id = LwfU
// module chunks = 273